import OWContainer from 'styles/styled-components/ow-container';
import { Spinner } from 'components/design';
import { PromotionForm } from '../components/promotion-form';
import useController from '../controllers/add-promotion-controller';

export const AddPromotionRoute = () => {
    const {
        formData,
        places,
        products,
        placeIds,
        onSubmit,
        onCancel,
        onChange,
        isLoading,
        isAddPromotionLoading,
        errors,
        isAdmin,
        placeId,
        productConfigData,
        handlePlaceIdsSelectChange,
        handleProductSelectChange,
        handleProductConfigPriceChange,
    } = useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <PromotionForm
                    formData={formData}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onChange={onChange}
                    isSaveLoading={isAddPromotionLoading}
                    errors={errors}
                    isAdmin={isAdmin}
                    placeId={placeId}
                    places={places}
                    products={products}
                    placeIds={placeIds}
                    onPlaceIdsSelectChange={handlePlaceIdsSelectChange}
                    onProductSelectChange={handleProductSelectChange}
                    productConfigData={productConfigData}
                    onConfigPriceChange={handleProductConfigPriceChange}
                />
            )}
        </OWContainer>
    );
};
